import { State } from "../types/State";

export async function saveSearch(button: Element) {
  const nonce = document
    .getElementById("search-form")
    ?.getAttribute("data-nonce");
  if (!nonce) window.location.replace(".#");
  else {
    button.innerHTML = "...";
    const headers = new Headers();
    headers.append("X-WP-Nonce", nonce);
    const url = new URL(window.location.href);
    fetch("/wp-json/api/save_search", {
      method: "POST",
      body: JSON.stringify(url.search),
      headers,
    }).then(
      (res) =>
        (button.innerHTML =
          res.status === 200 ? "Enregistré !" : "Une erreur est survenue")
    );
  }
}
